import React, { Component } from 'react';

export default class PortalAccountFullDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      text: props.initialValue || 'placeholder',
      appraisal_data: '',
      expenses_data: '',
      expense_approval_data: {},
      account_notifications_data: '',
      isLoadingAppraisalInfo: true,
      isLoadingExpensesInfo: true,
      isLoadingInvoiceInfo: true,
      driverPriceOption:(this.props.data.driver_id != null && this.props.data.driver && this.props.data.driver.driver_price_option) ? this.props.data.driver.driver_price_option : '' || '',
      isOtherDriverPrice:false
    };

    let that = this;
    Echo.channel('notifications-for-account-'+this.props.data.id)
      .listen('NewAccountNotification', (e) => {
        that.getAccountNotifications();
      });
    this.getAccountNotifications();
  }

  getAccountNotifications() {
    let url = '/api/v1/portal/portal-admin/notifications/'+this.props.data.id;
    return fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer '+window.api_token
        ,"Accept": 'application/json'
      },
    }).
    then((responseText) => {
      let response = responseText.json();
      response.then((accountNotificationsJson) => {
        this.setState({
          account_notifications_data: accountNotificationsJson,
          isLoading: false
        })
      });
    });
  }

  setPortalAccountOnHoliday() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/set-account-on-holiday/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',

    })
      .done(function(data) {
        //  alert('aborted');
      });
  }

  setPortalAccountNotOnHoliday() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/set-account-not-on-holiday/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  lockPortalAccount() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/lock-account/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',

    })
      .done(function(data) {
          $('#infomodallabel').html('Success');
          $('#infomodal .modal-body').html(data);
          $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

  unlockPortalAccount() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/unlock-account/"+this.props.data.id,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html(data);
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }
  handleChecked(e){
    let isChecked = e.target.checked;
    $.ajax({
      url: "/api/v1/portal/portal-admin/mark-driver-archieved/"+this.props.data.id,
      data: {api_token: window.api_token,is_driver_archieved:(isChecked) ? 1 : 0},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html('Saved successfully');
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

  changePortalAccountPassword() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-password/"+this.props.data.id,
      data: {api_token: window.api_token,
        new_password: $('#portal-account-full-details-'+this.props.data.id+' input[name=new_password]').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  changePortalAccountName() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-name/"+this.props.data.id,
      data: {api_token: window.api_token,
        first_name: $('#portal-account-full-details-'+this.props.data.id+' input[name=first_name]').val(),
        last_name: $('#portal-account-full-details-'+this.props.data.id+' input[name=last_name]').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }

  changePortalAccountEmailAddress() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-email-address/"+this.props.data.id,
      data: {api_token: window.api_token,
        new_email: $('#portal-account-full-details-'+this.props.data.id+' input[name=new_email]').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }


  changePortalAccountRoles() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-account-roles/"+this.props.data.id,
      data: {api_token: window.api_token,
        role_is_planner: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_planner]:checked').val(),
        role_is_financial: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_financial]:checked').val(),
        role_is_portal_admin: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_portal_admin]:checked').val(),
        role_is_portal_super_admin: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_portal_super_admin]:checked').val(),
        role_is_company_admin: $('#portal-account-full-details-'+this.props.data.id+' [name=role_is_company_admin]:checked').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        //  alert('unaborted');
      });
  }
  changeUserComapnyAccesibility() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-user-account-company-access/"+this.props.data.id,
      data: {api_token: window.api_token,
        allowed_access_for_acv: $('#portal-account-full-details-'+this.props.data.id+' [name=allowed_access_for_acv]:checked').val(),
        allowed_access_for_bvl: $('#portal-account-full-details-'+this.props.data.id+' [name=allowed_access_for_bvl]:checked').val(),
        allowed_access_for_g4: $('#portal-account-full-details-'+this.props.data.id+' [name=allowed_access_for_g4]:checked').val(),
        allowed_access_for_cnd: $('#portal-account-full-details-'+this.props.data.id+' [name=allowed_access_for_cnd]:checked').val(),
        allowed_access_for_sccd: $('#portal-account-full-details-'+this.props.data.id+' [name=allowed_access_for_sccd]:checked').val()},
      cache: false,
      method: 'post',
    })
      .done(function(data) {
        $('#infomodallabel').html('Success');
        $('#infomodal .modal-body').html(data);
        $('#infomodal').modal();
      })
      .catch(function(err) { 
        let errors = err.responseText; 
        errors = JSON.parse(errors);

        $('#infomodallabel').html('Error');
        $('#infomodal .modal-body').html('Sorry, '+errors.error);
        $('#infomodal').modal();
        
      });
  }

  changePortalAccountDriverEmergencyContactInfo() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-emergency-contact-info/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_emergency_contact_name: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_emergency_contact_name]').val(),
        driver_emergency_contact_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_emergency_contact_number]').val()
      },
      cache: false,
      method: 'post',
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver emergency contact info updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the emergency contact details for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverContactNumber() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-contact-number/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_contact_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_phone_number]').val(),
      },
      cache: false,
      method: 'post',
      dataType: "text/json",
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver contact number updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem changing the contact number for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverEquipmentKitSettings() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-equipment-kit-settings/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_has_got_tablet: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_tablet]:checked').val(),
        driver_has_got_uniform: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_uniform]:checked').val(),
        driver_has_got_id_card: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_id_card]:checked').val(),
        driver_has_got_breakdown_cover: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_has_got_breakdown_cover]:checked').val()
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver equipment/kit info updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the equipment/kit information for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverHomeAddress() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-home-address/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_home_address_house_number_or_name: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_house_number_or_name]').val(),
        driver_home_address_address_line_1: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_address_line_1]').val(),
        driver_home_address_address_line_2: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_address_line_2]').val(),
        driver_home_address_address_line_3: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_address_line_3]').val(),
        driver_home_address_town_city: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_town_city]').val(),
        driver_home_address_county_area: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_county_area]').val(),
        driver_home_address_country: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_country]').val(),
        driver_home_address_postcode: $(
          '#portal-account-full-details-' + this.props.data.id +
          ' [name=driver_home_address_postcode]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver home address updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the equipment/kit information for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverPointsOnLicense() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-points-on-license/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_points_on_license: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_points_on_license]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver points on license updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the points on license for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }

  changePortalAccountDriverTradePlateNumber() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-trade-plate-number/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_trade_plate_number: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_trade_plate_number]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver trade plate number updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the trade plate number for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }
  changePortalAccountDriverSharePercentage() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-account-share-percentage/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_share_of_profit: $('#portal-account-full-details-' + this.props.data.id + ' [name=driver_share_of_profit]').val(),
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Info Edited.');
          $('#infomodal .modal-body').html('Driver share profit updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the share profit for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }
  changePortalAccountDriverPriceOption() {
    $.ajax({
      url: "/api/v1/portal/portal-admin/change-driver-price-option/"+this.props.data.id,
      data: {
        api_token: window.api_token,
        driver_price_option: this.state.driverPriceOption,
      },
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status === 200) {
          $('#infomodallabel').html('Driver Price Option Saved.');
          $('#infomodal .modal-body').html('Driver price option updated.');
          $('#infomodal').modal();
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html('Sorry, there was a problem saving changes to the price for this driver.');
          $('#infomodal').modal();
        }
      }
    });
  }
  renderPortalAccountNotifications() {
    let AccountNotifications = [];
    if (this.state.account_notifications_data.length > 0) {
      let jobId = this.props.data.id;
      this.state.account_notifications_data.forEach(function(i) {
        AccountNotifications.push(
          <div key={"job-"+jobId+"-notification-"+i.id}>
            <div className="profile-container">
              <span className="small sidebar-time">{i.sidebar_time}</span>
              <img src={"/user-images/"+i.user_id} width="50" height="50" />
              <span>
              <a href={"/portal-admin/users/view/"+i.user_id}>
                {i.user_name}
              </a> from <a href={"/portal-admin/companies/"+i.user_company_short_name}>
                {i.user_company_short_name}
              </a>
            </span>
            </div>
            <div dangerouslySetInnerHTML={{__html: i.message}} className="text-right"></div>
            <hr />
          </div>);
      });
    }

    return (
      <div className="jobs-table-job-notifications-container">{AccountNotifications}</div>
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data.email !== nextProps.data.email) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=new_email]').value = (nextProps.data.email);
    }

    if (this.props.data.first_name !== nextProps.data.first_name) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=first_name]').value = (nextProps.data.first_name);
    }

    if (this.props.data.last_name !== nextProps.data.last_name) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=last_name]').value = (nextProps.data.last_name);
    }

    if (this.props.data.last_name !== nextProps.data.last_name) {
      document.querySelector("#portal-account-full-details-"+this.props.data.id+
        ' input[name=last_name]').value = (nextProps.data.last_name);
    }

    if (this.props.data.driver_id !== null) {
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_emergency_contact_name]').value = (
        nextProps.data.driver.emergency_contact
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_emergency_contact_number]').value =
        (nextProps.data.driver.emergency_contact_number
        );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_phone_number]').value = (
        nextProps.data.driver.contact_number
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_trade_plate_number]').value = (
        nextProps.data.driver.trade_plate_number
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_points_on_license]').value = (
        nextProps.data.driver.points_on_license
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_house_number_or_name]').value = (
        nextProps.data.driver.home_address.house_number_or_name
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_address_line_1]').value = (
        nextProps.data.driver.home_address.address_line_1
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_address_line_2]').value = (
        nextProps.data.driver.home_address.address_line_2
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_address_line_3]').value = (
        nextProps.data.driver.home_address.address_line_3
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_town_city]').value = (
        nextProps.data.driver.home_address.town_city
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_county_area]').value = (
        nextProps.data.driver.home_address.county_area
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_country]').value = (
        nextProps.data.driver.home_address.country
      );
      document.querySelector("#portal-account-full-details-" + this.props.data.id +
        ' input[name=driver_home_address_postcode]').value = (
        nextProps.data.driver.home_address.postcode
      );
    }
  }
  handleDriverPriceOption(e){
    if(e.currentTarget.value == 'other'){
      this.setState({isOtherDriverPrice:true,driverPriceOption:''});
    }else{
      this.setState({driverPriceOption:e.currentTarget.value,isOtherDriverPrice:false});
    }
  }
  handleDriverPriceOptionText(e){
    this.setState({driverPriceOption:e.currentTarget.value});
  }
  render() {
    let roles = this.props.data.roles,
        isRolePortalSuperAdmin = roles.find(o => o.name === 'portal_super_admin'),
        isRoleSystemAdmin = roles.find(o => o.name === 'portal_admin'),
        isRoleFinancial = roles.find(o => o.name === 'financial'),
        isRolePlanner = roles.find(o => o.name === 'planner'),
        isRoleCompanyAdmin = roles.find(o => o.name === 'company_admin'),
        hasDriverGotTheirUniform = 0,
        hasDriverGotTheirTablet = 0,
        hasDriverGotTheirIdCard = 0,
        hasDriverGotBreakdownCover = 0,
        driverPointsOnLicense = 0,
        driverEmergencyContactName = '',
        driverEmergencyContactNumber = '',
        driverPhoneNumber = '',
        driverHomeAddressHouseNumberOrName = '',
        driverHomeAddressAddressLine1 = '',
        driverHomeAddressAddressLine2 = '',
        driverHomeAddressAddressLine3 = '',
        driverHomeAddressTownCity = '',
        driverHomeAddressCountyArea = '',
        driverHomeAddressCountry = '',
        driverHomeAddressPostcode = '',
        isAllowedToAccessACV = this.props.data.allowed_access_for_acv,
        isAllowedToAccessBVL = this.props.data.allowed_access_for_bvl,
        isAllowedToAccessG4 = this.props.data.allowed_access_for_g4,
        isAllowedToAccessCND = this.props.data.allowed_access_for_cnd,
        isAllowedToAccessSCCD = this.props.data.allowed_access_for_sccd;
    if (this.props.data.driver_id !== null && this.props.data.driver) {
      hasDriverGotTheirUniform = this.props.data.driver.got_uniform;
      hasDriverGotTheirTablet = this.props.data.driver.got_tablet;
      hasDriverGotTheirIdCard = this.props.data.driver.got_id_card;
      hasDriverGotBreakdownCover = this.props.data.driver.got_breakdown_cover;
      driverPointsOnLicense = this.props.data.driver.points_on_license;

      driverEmergencyContactName = this.props.data.driver.emergency_contact;
      driverEmergencyContactNumber = this.props.data.driver.emergency_contact_number;

      driverPhoneNumber = this.props.data.driver.contact_number;

      driverHomeAddressHouseNumberOrName = this.props.data.driver.home_address.house_number_or_name;
      driverHomeAddressAddressLine1 = this.props.data.driver.home_address.address_line_1;
      driverHomeAddressAddressLine2 = this.props.data.driver.home_address.address_line_2;
      driverHomeAddressAddressLine3 = this.props.data.driver.home_address.address_line_3;
      driverHomeAddressTownCity = this.props.data.driver.home_address.town_city;
      driverHomeAddressCountyArea = this.props.data.driver.home_address.county_area;
      driverHomeAddressCountry = this.props.data.driver.home_address.country;
      driverHomeAddressPostcode = this.props.data.driver.home_address.postcode;
    }

    return (
      <div
        className="portal-admin-table-row portal-account-full-details"
        id={"portal-account-full-details-"+this.props.data.id}
        key={"portal-account-full-details-"+this.props.data.id}
      >
        <div className="row">
          <div className="col-md-3">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Permissions and roles</h3>
              <div>
                <h5>Roles</h5>
              </div>
              <div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Company Admin?
                    <input type="checkbox" name="role_is_company_admin"
                           defaultValue="true"
                           defaultChecked={isRoleCompanyAdmin}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Planner?
                    <input type="checkbox" name="role_is_planner"
                           defaultValue="true"
                           defaultChecked={isRolePlanner}  />


                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Financial?
                    <input type="checkbox" name="role_is_financial"
                           defaultValue="true"
                           defaultChecked={isRoleFinancial}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Portal Admin?
                    <input type="checkbox" name="role_is_portal_admin"
                           defaultValue="true"
                           defaultChecked={isRoleSystemAdmin}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} a Portal Super Admin?
                    <input type="checkbox" name="role_is_portal_super_admin"
                           defaultValue="true"
                           defaultChecked={isRolePortalSuperAdmin}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <p className="text-center">
                  <button className="btn btn-success" onClick={() => {
                    this.changePortalAccountRoles(this.props.data.id)}}>
                    <i className="fa fa-save"></i> Save Role Settings
                  </button>
                </p>
              </div>
              {/* <div>
                <h5>Company Permission</h5>
              </div> */}
              {/* <div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} allowed to access ACV company?
                    <input type="checkbox" name="allowed_access_for_acv"
                           defaultValue="true"
                           defaultChecked={isAllowedToAccessACV}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} allowed to access BVL company?
                    <input type="checkbox" name="allowed_access_for_bvl"
                           defaultValue="true"
                           defaultChecked={isAllowedToAccessBVL}  />


                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} allowed to access CND company?
                    <input type="checkbox" name="allowed_access_for_cnd"
                           defaultValue="true"
                           defaultChecked={isAllowedToAccessCND}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} allowed to access G4 company?
                    <input type="checkbox" name="allowed_access_for_g4"
                           defaultValue="true"
                           defaultChecked={isAllowedToAccessG4}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} allowed to access SCCD company?
                    <input type="checkbox" name="allowed_access_for_sccd"
                           defaultValue="true"
                           defaultChecked={isAllowedToAccessSCCD}  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
                <p className="text-center">
                  <button className="btn btn-success" onClick={() => {
                    this.changeUserComapnyAccesibility(this.props.data.id)}}>
                    <i className="fa fa-save"></i> Save Company Settings
                  </button>
                </p>
              </div> */}
            </div>
            {this.props.data.driver_id != null ?
              <div
                className="portal-admin-table-full-details-column-container
                 drivers-details">
                <h3>Driver's Details</h3>

                <div>
                  <h5>Points on {this.props.data.first_name}'s License</h5>
                </div>

                <div className="text-center">
                  <p>
                    <input
                      type="text"
                      name="driver_points_on_license"
                      className="form-control form-control-lg text-center"
                      maxLength="2"
                      defaultValue={driverPointsOnLicense}
                    />
                  </p>
                  <p className="text-center">
                    <button
                      className="btn btn-success"
                      onClick={() => {
                        this.changePortalAccountDriverPointsOnLicense(
                          this.props.data.id
                        )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Points on License
                    </button>
                  </p>
                </div>


                <div>
                  <h5>Emergency Contact</h5>
                </div>


                  <div>
                  <p>
                    <label>Name:&nbsp;</label>
                    <input type="text"
                           name="driver_emergency_contact_name"
                           className="form-control form-control-lg"
                           defaultValue={driverEmergencyContactName}
                    />
                  </p>

                  <p>
                    <label>Number:&nbsp;</label>
                    <input type="text"
                           className="form-control form-control-lg"
                           name="driver_emergency_contact_number"
                           defaultValue={driverEmergencyContactNumber}
                    />
                  </p>

                  <p className="text-center">
                    <button
                      className="btn btn-lg btn-success"
                      onClick={() => {
                        this.changePortalAccountDriverEmergencyContactInfo(
                          this.props.data.id
                        )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Emergency Contact
                    </button>
                  </p>
                  </div>


                <div>
                  <h5><i className="fa fa-phone"> </i> Contact Number</h5>
                </div>
                <div className="text-left">
                  <div>
                    <label>
                      {this.props.data.first_name}'s phone number:&nbsp;
                    </label>

                    <input
                      type="text" name="driver_phone_number"
                      defaultValue={driverPhoneNumber}
                      className="form-control form-control-lg"
                    />
                  </div>
                  <br />
                  <p className="text-center">
                    <button className="btn btn-lg btn-success" onClick={() => {
                      this.changePortalAccountDriverContactNumber(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes<br /> to Contact Number
                    </button>
                  </p>
                </div>

                <div>
                  <h5><i className="fa fa-home"> </i> Driver Home Address</h5>
                </div>
                <div className="text-left">
                  <div>
                    <p>
                      {this.props.data.first_name}'s home address:
                    </p>

                    <p>
                      <strong>House Number or Name:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_house_number_or_name"
                        defaultValue={driverHomeAddressHouseNumberOrName}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Address Line 1:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_address_line_1"
                        defaultValue={driverHomeAddressAddressLine1}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Address Line 2:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_address_line_2"
                        defaultValue={driverHomeAddressAddressLine2}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Address Line 3:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_address_line_3"
                        defaultValue={driverHomeAddressAddressLine3}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Town/City:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_town_city"
                        defaultValue={driverHomeAddressTownCity}
                        className="form-control form-control-lg"
                      />
                    </p>


                    <p>
                      <strong>County/Area:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_county_area"
                        defaultValue={driverHomeAddressCountyArea}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Country:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_country"
                        defaultValue={driverHomeAddressCountry}
                        className="form-control form-control-lg"
                      />
                    </p>

                    <p>
                      <strong>Postcode:</strong>
                      <br />
                      <input
                        type="text" name="driver_home_address_postcode"
                        defaultValue={driverHomeAddressPostcode}
                        className="form-control form-control-lg"
                      />
                    </p>


                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverHomeAddress(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i>&nbsp;
                      Save Changes to Driver's Home Address
                    </button>
                  </p>
                </div>

                <div>
                  <h5>Equipment/Kit</h5>
                </div>

                <div>
                  <div className="checkbox">
                    <label> Has this driver got their uniform?
                      <input type="checkbox" name="driver_has_got_uniform"
                             defaultValue="true"
                             defaultChecked={hasDriverGotTheirUniform}  />

                      <span className="cr">
                      <i className="cr-icon fa fa-check"> </i>
                    </span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Has this driver got their tablet?
                      <input type="checkbox" name="driver_has_got_tablet"
                             defaultValue="true"
                             defaultChecked={hasDriverGotTheirTablet}  />
                      <span className="cr">
                      <i className="cr-icon fa fa-check"> </i>
                    </span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Has this driver got their ID Card?
                      <input type="checkbox" name="driver_has_got_id_card"
                             defaultValue="true"
                             defaultChecked={hasDriverGotTheirIdCard}  />
                      <span className="cr"><i className="cr-icon fa fa-check"> </i></span>
                    </label>
                  </div>

                  <div className="checkbox">
                    <label> Has this driver got breakdown cover?
                      <input type="checkbox" name="driver_has_got_breakdown_cover"
                             defaultValue="true"
                             defaultChecked={hasDriverGotBreakdownCover}  />
                      <span className="cr"><i className="cr-icon fa fa-check"> </i></span>
                    </label>
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverEquipmentKitSettings(
                        this.props.data.id
                      )}}>
                      <i className="fa fa-save"> </i> Save Changes to Equipment Info
                    </button>
                  </p>

                </div>

                <div>
                  <h5>Trade Plate Number</h5>
                </div>
                <div className="text-left">
                  <div>
                    <label>
                      {
                        this.props.data.first_name
                      }'s Trade Plate:</label>
                    <br />
                    <input
                      type="text"
                      name="driver_trade_plate_number"
                      defaultValue={this.props.data.driver.trade_plate_number}
                      className="form-control form-control-lg"
                    />
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverTradePlateNumber(
                        this.props.data.id)
                    }}>
                      <i className="fa fa-save"> </i>
                      Save Changes to Trade Plate
                    </button>
                  </p>
                </div>

                <div>
                  <h5>Driver Price Options</h5>
                </div>
                <div className="text-left job-ref-font20">
                  <div>
                    <label>
                      {
                        this.props.data.first_name
                      }'s Driver Price:</label>
                    <br />
                    <div>
                      <label className="radio-inline">
                        <input type="radio" name="driver_price_radio" value="20" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '20') ? true : false}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 20 &nbsp;
                      </label>
                      <label className="radio-inline">
                        <input type="radio" name="driver_price_radio"  value="25" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '25') ? true : false}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; 25 &nbsp;
                      </label>
                      {/* <label className="radio-inline">
                        <input type="radio" name="driver_price_radio"  value="other" 
                        defaultChecked={(this.props.data.driver.driver_price_option == '20' || this.props.data.driver.driver_price_option == '25' ) ? false : true}
                        onChange={(e)=>this.handleDriverPriceOption(e)}/>&nbsp; Other
                      </label> */}
                    </div>
                    {/* {(this.state.isOtherDriverPrice) ? 
                      <div>
                        <input type="text" name="driver_price_radio_text" 
                        className="form-control form-control-lg" 
                        placeholder="Enter amount"
                        value={this.state.driverPriceOption}
                        onChange={(e)=>this.handleDriverPriceOptionText(e)}/>
                      </div>
                    : null} */}
                  </div>

                  <p className="text-center">
                    <button className="btn btn-success" onClick={() => {
                      this.changePortalAccountDriverPriceOption(
                        this.props.data.id)
                    }}>
                      <i className="fa fa-save"> </i>&nbsp; Save Changes to Driver Price
                    </button>
                  </p>
                </div> 

                <div>
                  <h5>Driver Share of Profit %</h5>
                </div>
                <div className="text-left job-ref-font20">
                  <div>
                    <label>
                      {
                        this.props.data.first_name
                      }'s Share of Profit:</label>
                    <br />
                    <div className="input-group driver_share_of_profit_percentage_block">
                      <input
                        type="text"
                        name="driver_share_of_profit"
                        defaultValue={(this.props.data.driver.driver_share_of_profit) ? this.props.data.driver.driver_share_of_profit:''}
                        className="form-control form-control-lg"
                      />
                      <div className="input-group-append">
                        <span className="input-group-text" id="basic-addon2">&nbsp; % &nbsp;</span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <p className="text-center">
                    <button className="btn btn-success btn-lg" onClick={() => {
                      this.changePortalAccountDriverSharePercentage(
                        this.props.data.id)
                    }}>
                      <i className="fa fa-save"> </i>&nbsp; Save Changes to share of profit %
                    </button>
                  </p>
                </div>

              </div>
              : null
            }
          </div>

          <div className="col-md-6">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Portal Activity</h3>
              <div>{
                this.renderPortalAccountNotifications()
              }</div>
            </div>
          </div>

          <div className="col-md-3">
            <div className="portal-admin-table-full-details-column-container">
              <h3>Admin Controls</h3>

              <div>
                <p>
                  <strong>Holiday Status</strong>
                </p>
                <p>
                  Current Status: '{
                  this.props.data.account_holiday_status
                }'<br />
                </p>
                <div className="text-right">
                  {this.props.data.account_holiday_status === 'on_holiday' ?
                    <button onClick={() => {
                      this.setPortalAccountNotOnHoliday(this.props.data.id)}}
                            className="btn btn-danger">
                      <i className="fa fa-pause"> </i> On Holiday
                    </button>
                    :
                    <button onClick={() => {
                      this.setPortalAccountOnHoliday(this.props.data.id)}}
                            className="btn btn-success">
                      <i className="fa fa-play"></i> Not on Holiday
                    </button>
                  }
                </div>
              </div>
              <div>
                <p>
                  <strong>Lock Account</strong>
                </p>
                <p>
                  Current Status: '{this.props.data.account_status}'<br />
                </p>
                <div className="text-right">
                  {this.props.data.account_status === 'locked' ?
                    <button onClick={() => {
                      this.unlockPortalAccount(this.props.data.id)}}
                            className="btn btn-danger">
                      <i className="fa fa-lock"></i> Account locked
                    </button>
                    :
                    <button onClick={() => {
                      this.lockPortalAccount(this.props.data.id)}}
                            className="btn btn-success">
                      <i className="fa fa-unlock"></i> Active
                    </button>
                  }
                </div>
              </div>
              {(this.props.data.driver_id !== null && this.props.data.driver) ?
              <div>
                <p>
                  <strong>Archive Driver</strong>
                </p>
                <div className="checkbox">
                  <label> Is {this.props.data.first_name} Driver Archived?
                    <input type="checkbox" name="is_driver_archieved"
                           defaultValue={this.props.data.is_driver_archieved}
                           defaultChecked={this.props.data.is_driver_archieved}
                           onChange={(e) => this.handleChecked(e) }  />

                    <span className="cr">
                      <i className="cr-icon fa fa-check"></i>
                    </span>
                  </label>
                </div>
              </div>
              : ''}
              
              <div>
                <p><strong>Change Name</strong></p>
                <div className="input-group m-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="user-first-name">First Name: </span>
                  </div>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    aria-label="First Name"
                    aria-describedby="user-first-name"
                    defaultValue={this.props.data.first_name} />
                </div>
                <div className="input-group m-3">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text"
                      id="user-last-name">Last Name: </span>
                  </div>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    aria-label="Last Name"
                    aria-describedby="user-last-name"
                    defaultValue={this.props.data.last_name} />
                </div>
                <p className="text-right">
                  <button onClick={() => {
                    this.changePortalAccountName(
                      this.props.data.id
                    )}}
                          className="btn btn-primary">
                    Update Name for this user
                  </button>
                </p>
              </div>
              <div>
                <p>
                  <strong>Change Email Address</strong>
                </p>
                <p>
                  <input
                    type="text"
                    name="new_email"
                    className="form-control"
                    defaultValue={this.props.data.email} />
                </p>
                <p className="text-right">
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      this.changePortalAccountEmailAddress(
                        this.props.data.id
                      )}}>
                    Change Email Address
                  </button>
                </p>
              </div>
              <div>
                <p><strong>Change Password</strong></p>
                <p>
                  <input
                    type="text"
                    className="form-control"
                    name="new_password"
                    placeholder="New Password Here" />
                </p>
                <p className="text-right">
                  <button onClick={() => {
                    this.changePortalAccountPassword(
                      this.props.data.id
                    )}}
                          className="btn btn-primary">
                    Update Password For this User
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}